export const REDUX_OFFER_TYPES = {
  SELECTED_OFFER: 'SELECTED_OFFER',
  OFFER_ERRORS: 'SET_OFFER_ERRORS',
  COUNTER_MODE_ON: 'COUNTER_MODE_ON',
  CURRENT_OFFERS: 'CURRENT_OFFERS',
  RESET: 'RESET',
  OFFER_SENT: 'OFFER_SENT',
  SHOW_ROUTE_OF: 'SHOW_ROUTES_OF',
  OFFERING_TO_LOAD: 'OFFERING_TO_LOAD',
  OFFERING_TO_TRUCK: 'OFFERING_TO_TRUCK',
  OFFERING_TO_MATCH: 'OFFERING_TO_MATCH'
}

export const dispatchSelectedOffer = (data) => (dispatch) => dispatch({
  type: REDUX_OFFER_TYPES.SELECTED_OFFER,
  payload: data
})

export const dispatchShowRouteOf = (data) => (dispatch) => dispatch({
  type: REDUX_OFFER_TYPES.SHOW_ROUTE_OF,
  payload: data
})

export const dispatchOfferSent = (sent) => (dispatch) => dispatch({
  type: REDUX_OFFER_TYPES.OFFER_SENT,
  payload: sent
})

export const dispatchOfferReset = (data) => (dispatch) => dispatch({
  type: REDUX_OFFER_TYPES.RESET,
  payload: data
})

export const dispatchOfferErrors = (errors) => (dispatch) => dispatch({
  type: REDUX_OFFER_TYPES.OFFER_ERRORS,
  payload: errors
})

export const dispatchCounterMode = (onOff) => (dispatch) => dispatch({
  type: REDUX_OFFER_TYPES.COUNTER_MODE_ON,
  payload: onOff
})

export const dispatchOffers = (offers) => (dispatch) => dispatch({
  type: REDUX_OFFER_TYPES.CURRENT_OFFERS,
  payload: offers
})

export const dispatchOfferingToLoad = (transasction) => (dispatch) => dispatch({
  type: REDUX_OFFER_TYPES.OFFERING_TO_LOAD,
  payload: transasction
})

export const dispatchOfferingToTruck = (transasction) => (dispatch) => dispatch({
  type: REDUX_OFFER_TYPES.OFFERING_TO_TRUCK,
  payload: transasction
})

export const dispatchOfferingToMatch = (transasction) => (dispatch) => dispatch({
  type: REDUX_OFFER_TYPES.OFFERING_TO_MATCH,
  payload: transasction
})
